import { Tabs } from "antd";
import React, { useEffect } from "react";
import ConfigurationWeekHour from "./ConfigurationWeekHour";
import { Calendar } from "../../../models/calendar/Calendar.model";
import ConfigurationSetUsers from "./ConfigurationSetUsers";
import ConfigurationAbsences from "./ConfigurationAbsences";
import { useModalCalendar } from "../../../contexts/calendar/ModalCalendarContext.context";
import { useUser } from "../../../contexts/UserContext";


type Props = {
    calendar:Calendar
}

const ConfigurationCalendar = ({ calendar }: Props) => {
  const {setOptions} = useModalCalendar();
  const {user} = useUser();
  useEffect(() => {
    console.log('Calendar en ConfigurationCalendar:',calendar);
  }, [calendar]);

  const handlerChangeTab = (activeKey: string)=>{
    setOptions((prev)=>({
      ...prev,
      width: activeKey==='work-hours' ? '520px' : '720px'
    }))
  }

  const itemTabs = [
    {
      label: 'Horas Hábiles',
      key: 'work-hours',
      children: <ConfigurationWeekHour calendar={calendar}/>,
    }
  ]
  if(user?.permissions?.views?.includes("calendar.calendars.main.options.view.configuration_users")){
    itemTabs.push({
      label: 'Agregar Usuarios Calendario',
      key: 'users-calendar',
      children: <ConfigurationSetUsers calendar={calendar}/>,
    })
    itemTabs.push({
      label: 'Ausencias',
      key: 'absences-calendar',
      children: <ConfigurationAbsences calendar={calendar}/>,
    })
  }
  return (
    <div className="py-6 px-4 rounded-2xl bg-gray-50 text-gray-800">
    <Tabs
        tabPosition={'top'}
        onChange={(activeKey: string) => handlerChangeTab(activeKey)}
        items={itemTabs}
      />
    </div>
  );
};

export default ConfigurationCalendar;
